import { Component, model, OnInit, signal } from '@angular/core';
import { BaseEntityComponent, EntityOrderedRequestParameters, EntityPagedRequestParameters, EntityPagedResult } from '@bndes/bndes-ux4/bndes-angular-utils';
import { BnOrdenacaoComponent } from '@bndes/bndes-ux4/bn-ordenacao';
import { BnPaginacaoComponent } from '@bndes/bndes-ux4/bn-paginacao';
import { BnMaskPipe } from '@bndes/bndes-ux4/bn-mask/bn-mask-pipe';
import { RouterLink } from '@angular/router';
import { DetalheDistribuicaoLimiteAgenteDto, LimiteAgenteApuracaoRenunciaDto } from 'src/app/model/detalhe-distribuicao-limite-agente-dto.model';
import { DistribuicaoLimiteAgentesService } from './distribuicao-limite-agente.service';
import { ResultadoPaginado } from 'src/app/model/resultado';

@Component({
  selector: 'app-distribuicao-agentes',
  imports: [
    BnMaskPipe,
    BnPaginacaoComponent,
    BnOrdenacaoComponent,
    RouterLink
  ],
  templateUrl: './distribuicao-agentes.component.html',
  styleUrl: './distribuicao-agentes.component.scss',
  standalone: true,
})
export class DistribuicaoAgentesComponent extends BaseEntityComponent<DetalheDistribuicaoLimiteAgenteDto> implements OnInit {

  public atributosPaginacao!: EntityPagedResult<LimiteAgenteApuracaoRenunciaDto>;
  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao!: EntityOrderedRequestParameters;

  public agentesPaginados = signal<DetalheDistribuicaoLimiteAgenteDto[]>([]);
  public idCiclo = model<number>(0);

  constructor(private distribuicaoAgentesService: DistribuicaoLimiteAgentesService
  ) {
    super(distribuicaoAgentesService);
  }

  ngOnInit(): void {
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: 1,
      count: 0,
      list: []
    }
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
    this.route.params.subscribe(params => {
      this.idCiclo.set(params['id']);
      this.buscarAgentes(params['id']);
    })
  }

  buscarAgentes(idCiclo: number) {
    const pageParams = {
      pagina: this.atributosPaginacao.page, 
      limite: this.atributosPaginacao.pageSize
    };

    this.distribuicaoAgentesService.buscarAgentes(idCiclo, pageParams).subscribe({
      next: (response:  ResultadoPaginado<DetalheDistribuicaoLimiteAgenteDto>) => {
        this.agentesPaginados.set(response.resultados);

        this.atributosPaginacao.count = response.totalRegistrosSemPaginacao;
        this.atributosPaginacao.pages = Math.ceil(response.totalRegistrosSemPaginacao / this.atributosPaginacao.pageSize);
      },
      error: err => {
        console.error(err);
      }
    })
  }

  voltar() {
    this.router.navigate(['/distribuicao-limites-configuracao']);
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao.page = novaPagina.page;
    this.atributosPaginacao.pageSize = novaPagina.pageSize;
    this.buscarAgentes(this.idCiclo());
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }
  
  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.agentesPaginados.set(
      this.agentesPaginados().sort((a, b) => {
        if (ord.sentido == "asc") {
          return this.compara(a, b, ord.atributo as keyof DetalheDistribuicaoLimiteAgenteDto);
        }
        else {
          return -1 * this.compara(a, b, ord.atributo as keyof DetalheDistribuicaoLimiteAgenteDto);
        }
      })
    );
  }

  private compara(a: DetalheDistribuicaoLimiteAgenteDto | undefined, b: DetalheDistribuicaoLimiteAgenteDto | undefined, atributo: keyof DetalheDistribuicaoLimiteAgenteDto): number {
    const valA = this.fetchFromObject(a, atributo);
    const valB = this.fetchFromObject(b, atributo);
    
    if (valA == valB) {
      return 0;
    } else if (valA == undefined) {
      return -1;
    } else if (valB == undefined) {
      return 1;
    } else if (valA > valB) {
      return 1;
    } else {
      return -1;
    }
  }

  private fetchFromObject(obj: DetalheDistribuicaoLimiteAgenteDto | undefined, prop: keyof DetalheDistribuicaoLimiteAgenteDto) {

    if(typeof obj === 'undefined') {
      return false;
    }
    return obj[prop];
  }
}
